import React,{useEffect} from 'react';
import Codesandbox from './codesandbox.svg';
import {motion, useAnimation} from 'framer-motion';
import {useInView} from 'react-intersection-observer';
import Mockup from './Mockup.png';      

const projectContainerVariants = {
    hidden: {
        opacity:0,
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 1
        }
    }
}

const moreVariants = {
    hidden: {
        opacity:0
    },
    visible: {
        opacity:1
    }
}

const leftVariants = {
    hidden:{
        opacity:0,
        x:10
    },
    visible:{
        opacity:1,
        x:0,
        transition: {
            duration: 1,
            ease: 'easeOut'
        }
    }
}

// const rightVariants = {
//     hidden:{
//         opacity:0,
//         x:-10
//     },
//     visible:{
//         opacity:1,
//         x:0,
//         transition: {
//             duration: 1,
//             ease: 'easeOut'
//         }
//     }
// }

// const know1Variants = {
//     hidden: {
//         x:0
//     },
//     visible: {
//         x: 10,
//         transition: {
//             duration: 1,
//             repeat: Infinity,
//             repeatType:'reverse'
//         }
//     }
// }
// const know2Variants = {
//     hidden: {
//         x:0
//     },
//     visible: {
//         x: -10,
//         transition: {
//             duration: 1,
//             repeat: Infinity,
//             repeatType:'reverse'
//         }
//     }
// }


const workVariants = {
    hidden: {
        x:'-50vw',
        opacity:0
    },
    visible: {
        x:0,
        opacity: 1,
        transition: {
            duration: 1,
            ease:'easeOut'
        }
    }
}

function Project() {
    const controls = useAnimation()
    const {ref, inView} = useInView({triggerOnce:true})

    useEffect(() => {
        if (inView) {
            controls.start("visible")
        }
        if(!inView){
            controls.start("hidden")
        }
    }, [controls,inView])
    
    return (
        <>
            <motion.div
                ref={ref}
                variants={projectContainerVariants}
                initial="hidden"
                animate={controls}
                style={{
                fontFamily: 'Prompt',
                backgroundColor:'black',
                marginTop: '20vh'
            }}>

                <motion.div
                    ref={ref}
                    variants={workVariants}
                    className="project-heading">
                    Works
                </motion.div>

                <div
                    style={{
                    marginTop:'3vh',
                    marginLeft: '9vw',
                    marginRight:'9vw',
                    fontFamily: 'Prompt',
                    }}>
                    <div className="project1">
                        <motion.div
                            ref={ref}
                            variants={leftVariants}
                            className="project-desc">
                            This website is completely developed
                            by me from scratch using ReactJS library.
                            Each component of this website is
                            uniquely designed from scratch and is completely 
                            responsive.
                            {/* <motion.div
                                ref={ref}
                                variants={know1Variants}
                                style={{
                                color:'#834bff'
                            }}>
                                <u>know more</u> 
                            </motion.div> */}
                        </motion.div>
                        <motion.div
                            ref={ref}
                            variants={leftVariants}>
                            <img src={Mockup} alt="mockup"
                                className="mockup" />
                        </motion.div>
                    </div>

                    {/* <motion.div
                        ref={ref}
                        variants={rightVariants}
                        style={{
                            fontSize: '4.5vw',
                            textAlign:'right',
                            marginBottom:'3vh',
                            color:'white'
                    }}>
                        Weather-forecasting application <br/>
                        A web-based application that gives weather-data
                        of your current location.
                        <motion.div
                            ref={ref}
                            variants={know2Variants}
                            style={{
                            color:'#834bff'
                        }}>
                           <u>view project</u>  
                        </motion.div>
                    </motion.div>

                    <motion.div
                        ref={ref}
                        variants={leftVariants}
                        style={{
                            fontSize: '4.5vw',
                            textAlign:'left',
                            color:'white'
                    }}>
                        A multi-page website created as a part
                        of college project.
                        <motion.div
                            ref={ref}
                            variants={know1Variants}
                            style={{
                            color:'#834bff'
                        }}>
                            <u>view project</u> 
                        </motion.div>
                    </motion.div> */}

                    <motion.div
                        ref={ref}
                        variants={moreVariants}
                        className="more-project">
                            More work at 
                        <a className="a-container"
                            href="https://codesandbox.io/u/priyanshubhardwaj19dec">
                                <div className="codesandbox">
                                    codesandbox
                                </div>
                                <img src={Codesandbox} alt="codesandbox"
                                className="codesandbox-icon"/>
                            </a>
                    </motion.div>
                </div>

                
            </motion.div>
        </>
    )
}

export default Project
